module.exports = __webpack_public_path__ + "static/img/unisemBg.a40107c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/unisemBg.png
// module id = 4ClG
// module chunks = 1